import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import useTable from "../components/useTable";
import { Dimmer } from "../components/spinner";
import axios from "axios";
import { SearchInput } from "../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";

const CatalogoCuentaBancaria = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CODIGO", textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", },
    { label: "DESCRIPCION", textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", },
    { label: "N° CUENTA", textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idcuentabancaria.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.cuentabancaria.includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let orden = "idcuentabancaria";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setValues({});
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarCuenta = () => {
    props.onHideAceptaCatalogo(values);
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();
    setValues(item);
    btnAcepta.current.focus();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">Seleccionar Banco</h3>
        <a type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-6 m-0 mb-2 p-0">
            <SearchInput 
              onChange={handleSearch}
            />
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        values.idcuentabancaria === item.idcuentabancaria
                          ? "lightskyblue"
                          : "white",
                    }}
                    onClick={seleccionarFila(item)}
                  >
                    <td className="py-2 text-center">
                      {item.idcuentabancaria}
                    </td>
                    <td className="py-2 text-start">{item.nombre}</td>
                    <td className="py-2 text-start">{item.cuentabancaria}</td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={seleccionarCuenta}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default CatalogoCuentaBancaria;
